import { Link } from 'react-router-dom';

import { RegistrationStatus } from '@sayyesschool/common/entities/registration';
import ConfirmButton from '@sayyesschool/frontend/components/confirm-button';
import CopyButton from '@sayyesschool/frontend/components/copy-button';
import { StatusIcon } from '@sayyesschool/frontend/features/registrations';
import {
    ButtonGroup,
    IconButton,
    List,
    Text
} from '@sayyesschool/frontend/ui-components';

export default function MeetingRegistrationsList({
    meeting,
    onUpdate,
    onDelete
}) {
    return (
        <List interactive>
            {meeting.registrations?.map(registration =>
                <List.Item
                    key={registration.id}
                    content={
                        <Link to={`/learners/${registration.userId}`}>
                            <Text type="body-md">{`${registration.user?.firstname} ${registration.user?.lastname}`}</Text>
                            <Text type="body-sm">{registration.user?.email}</Text>
                        </Link>
                    }
                    end={
                        <ButtonGroup
                            variant="plain"
                            spacing="4px"
                        >
                            {(meeting.isScheduled || meeting.isStarted) && registration.joinUrl &&
                                <CopyButton
                                    title="Копировать ссылку для входа"
                                    icon="link"
                                    copyContent={registration.joinUrl}
                                />
                            }

                            {meeting.isEnded ? <>
                                <IconButton
                                    title="Отметить присутствие"
                                    icon={StatusIcon[RegistrationStatus.Attended]}
                                    color={registration.isAttended ? 'success' : undefined}
                                    variant={registration.isAttended ? 'soft' : undefined}
                                    onClick={() => onUpdate(registration, { status: RegistrationStatus.Attended })}
                                />

                                <IconButton
                                    title="Отметить отсутствие"
                                    icon={StatusIcon[RegistrationStatus.Missed]}
                                    color={registration.isMissed ? 'danger' : undefined}
                                    variant={registration.isMissed ? 'soft' : undefined}
                                    onClick={() => onUpdate(registration, { status: RegistrationStatus.Missed })}
                                />
                            </> : <>
                                <IconButton
                                    title="Подтвердить участие"
                                    icon={StatusIcon[RegistrationStatus.Approved]}
                                    color={registration.isApproved ? 'success' : undefined}
                                    variant={registration.isApproved ? 'soft' : undefined}
                                    onClick={() => onUpdate(registration, { status: RegistrationStatus.Approved })}
                                />

                                <IconButton
                                    title="Отменить участие"
                                    icon={StatusIcon[RegistrationStatus.Canceled]}
                                    color={registration.isCanceled ? 'danger' : undefined}
                                    variant={registration.isCanceled ? 'soft' : undefined}
                                    onClick={() => onUpdate(registration, { status: RegistrationStatus.Canceled })}
                                />
                            </>}

                            <ConfirmButton
                                title="Удалить"
                                message="Вы уверены, что хотите удалить регистрацию?"
                                description="Это действие нельзя отменить"
                                icon="delete"
                                color="danger"
                                onConfirm={() => onDelete(registration)}
                            />
                        </ButtonGroup>
                    }
                />
            )}
        </List>
    );
}